export default "/images/vendor/flag-icon-css/flags/1x1/kr.svg?9406f22f1237e7e4059d43ab60f9fbc8";